// extracted by mini-css-extract-plugin
export default {"input-card":"InputCard_input-card__1Da7M","border":"InputCard_border__g5ApE","input-title":"InputCard_input-title__dnCaJ"};